import { $playerProfile, fetchLeaderBoard, fetchMe } from '../../../app/backend/store';
import Controller from './controller/Controller';
import { TutorialStep } from '../../../types/alice-bob';
import { setTutorialStep } from '../../backend/store/tutorial';

type LayerName = 'bg' | 'enemy' | 'tapper' | 'heroes' | 'vfx' | 'gui' | 'popups' | 'popup_vfx';

export default class Game extends Phaser.Scene {
    private controller!: Controller;
    layers!: Record<LayerName, Phaser.GameObjects.Container>;

    constructor() {
        super('Game');
    }

    async create() {
        setTutorialStep(TutorialStep.LOADED_TUTORIAL);
        this.scene.run('Lazyloader');
        await fetchLeaderBoard();
        const chapterId = $playerProfile.getState().current_chapter
        console.log(chapterId)
        if (chapterId != 1) {
            this.game.events.emit('LOAD_CHAPTER_ASSETS')
            this.game.events.once('CHAPTER_ASSETS_LOADED', this.start, this)
        }
        else this.events.once('update', this.start, this);
    }

    async start() {
        console.log('start!')
        this.setLayers();
        window.Telegram.WebApp.setHeaderColor('#bbc8d2');
        this.cameras.main.setBackgroundColor('#fff');

        this.controller = new Controller(this);
    }

    setLayers() {
        const names: LayerName[] = ['bg', 'enemy', 'tapper', 'heroes', 'gui', 'vfx', 'popups', 'popup_vfx'];
        this.layers = {} as Record<LayerName, Phaser.GameObjects.Container>;

        names.forEach((name) => {
            this.layers[name] = this.add.container(0, 0);
        });
    }
}
